async function fetchDashboardInfo(companyUuid: string, type: string, from: string, to: string) {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}hospitality/get-Dashboard?companyUuid=${companyUuid}&type=${type}&from=${from}&to=${to}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      }
    }
  );

  const complaintData: any = await response.json();
  return complaintData;
}

async function fetchDashboardChartInfo(
  companyUuid: string,
  type: string,
  from: string,
  to: string,
  graph: string
) {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}hospitality/get-Dashboard-Graph?companyUuid=${companyUuid}&from=${from}&to=${to}&type=${type}&graph=${graph}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      }
    }
  );

  const GraphData: any = await response.json();
  return GraphData;
}

export { fetchDashboardInfo, fetchDashboardChartInfo };
